import { dasherize, titleize, underscore } from 'inflection'

export function toSlug(name: string, ensureSingleDash = true) {
  var id = name
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[^a-z0-9_-]/gi, '-')
  if (ensureSingleDash) {
    id = id.replace(/--+/gi, '-').replace(/^-|-$/g, '')
  }
  return dasherize(underscore(id))
}
